import './assets/main.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import moment from 'moment'
import 'moment/locale/de'
import pusher from '@/services/pusher.ts'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import router from './router'
import QuillEditor from '@/components/editor/QuillEditor.vue'
import VueRecaptcha from 'vue3-recaptcha2'

import App from './App.vue'
import registerFilters from '@/filters/RegisterGlobalFilters.ts'
//import ApiService from '@/services/ApiService.ts'

moment.locale('de')

const app = createApp(App)

registerFilters(app)

app.config.globalProperties.$pusher = pusher

//app.config.globalProperties.$apiService = new ApiService();

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(i18n)
app.component('QuillEditor', QuillEditor)
app.component('VueRecaptcha', VueRecaptcha)

app.mount('#app')
